module.exports = __webpack_public_path__ + "static/media/total-inprogress.eb2d208a.svg";